// import React from "react";
// import { ArrowRight } from "lucide-react";

// import "./ProjectFooter.scss";

// interface ProjectFooterProps {
//   impactTitle?: string;
//   impactLabel?: string;
//   impactDescription: string;
//   conclusion?: {
//     label: string;
//     title: string;
//     description: string;
//   };
//   nextProject?: {
//     title: string;
//     link?: string;
//   };
// }

// export function ProjectFooter({
//   impactTitle = "Project Impact",
//   impactLabel,
//   impactDescription,
//   conclusion,
//   nextProject,
// }: ProjectFooterProps) {
//   return (
//     <section className="projectFooter">
//       <div className="footerContainer">
//         {/* Impact Summary */}
//         <div className="footerImpact">
//           <h2 className="impactLabel">{impactLabel}</h2>
//           <h3 className="impactTitle">{impactTitle}</h3>
//           <p className="impactDescription">{impactDescription}</p>
//         </div>

//         {/* Conclusion */}
//         {conclusion && (
//           <div className="footerConclusion">
//             {conclusion.label && (
//               <div className="conclusionRole">{conclusion.label}</div>
//             )}
//             {conclusion.title && (
//               <div className="conclusionAuthor">{conclusion.title}</div>
//             )}
//             <p className="conclusionQuote">{conclusion.description}</p>
//           </div>
//         )}

//         {/* Next Project CTA */}
//         {nextProject && (
//           <div className="footerNextProject">
//             <div className="nextProjectContent">
//               <div className="nextProjectInfo">
//                 <div className="nextProjectLabel">Next Project</div>
//                 <div className="nextProjectTitle">{nextProject.title}</div>
//               </div>
//               <button className="nextProjectButton">
//                 <span>View Project</span>
//                 <ArrowRight className="buttonIcon" />
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Back to top */}
//         <div className="footerBackToTop">
//           <button
//             onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
//             className="backToTopButton"
//           >
//             Back to top ↑
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import "./ProjectFooter.scss";

interface ProjectFooterProps {
  impactTitle?: string;
  impactLabel?: string;
  impactDescription: string;
  conclusion?: {
    label: string;
    title: string;
    description: string;
  };
  nextProject?: {
    title: string;
    link?: string;
  };
}

export function ProjectFooter({
  impactTitle = "Project Impact",
  impactLabel,
  impactDescription,
  conclusion,
  nextProject,
}: ProjectFooterProps) {
  return (
    <section className="projectFooter">
      <div className="footerContainer">
        {/* Impact Summary */}
        <div className="footerImpact">
          <h2 className="impactLabel">{impactLabel}</h2>
          <h3 className="impactTitle">{impactTitle}</h3>
          <p className="impactDescription">{impactDescription}</p>
        </div>

        {/* Conclusion */}
        {conclusion && (
          <div className="footerConclusion">
            {conclusion.label && (
              <div className="conclusionRole">{conclusion.label}</div>
            )}
            {conclusion.title && (
              <div className="conclusionAuthor">{conclusion.title}</div>
            )}
            <p className="conclusionQuote">{conclusion.description}</p>
          </div>
        )}

        {/* Next Project CTA */}
        {nextProject && nextProject.link && (
          <div className="footerNextProject">
            <div className="nextProjectContent">
              <div className="nextProjectInfo">
                <div className="nextProjectLabel">Next Project</div>
                <div className="nextProjectTitle">{nextProject.title}</div>
              </div>

              <Link
                to={nextProject.link}
                className="nextProjectButton"
                style={{ textDecoration: "none" }}
              >
                <span>View Project</span>
                <ArrowRight className="buttonIcon" />
              </Link>
            </div>
          </div>
        )}

        {/* Back to top */}
        <div className="footerBackToTop">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="backToTopButton"
          >
            Back to top ↑
          </button>
        </div>
      </div>
    </section>
  );
}
